import { Colors, Utils } from '@lightningjs/sdk';
import Lightning from '@lightningjs/sdk/src/Lightning';

export default class Key extends Lightning.Component {
  static _template() {
    return {
      collision: true,

      color: Colors('#000000').get(),

      flex: { direction: 'row', justifyContent: 'center', alignItems: 'center' },
      Key: {
        collision: true,
        color: Colors('#000000').get(),
        flex: { direction: 'row', justifyContent: 'center', alignItems: 'center' },
        Title: {
          text: {
            fontFace: 'OpenSans-Regular',
            fontSize: 48,
          },
        },
      },
    };
  }

  get _Key() {
    return this.tag('Key');
  }

  get _Title() {
    return this.tag('Key.Title');
  }

  set index(val) {
    this._index = val;
  }

  set rowIndex(val) {
    this._rowIndex = val;
  }

  set data({ w, h, key, icon }) {
    this._data = { w, h, key, icon };
  }

  _enable() {
    // Apply common properties regardless of whether the icon exists or not
    this.patch({
      w: this._data.w,
      h: this._data.icon ? 70 : this._data.h, // Set height based on icon presence
    });

    // Handle the case when the icon exists
    if (this._data.icon) {
      this._Title.patch({
        w: this._data.w,
        h: this._data.h,
        texture: Lightning.Tools.getSvgTexture(
          Utils.asset(`/images/${this._data.icon}`),
          this._data.w,
          this._data.h
        ),
      });
    } else {
      // Handle the case when there is no icon, showing the key as text
      this._Title.patch({
        text: { text: this._data.key },
      });

      // Apply additional properties for elements without an icon
      this._Key.patch({
        texture: Lightning.Tools.getRoundRect(60, 70, 13, 4, Colors('#02AC25').get(), false),
        w: this._data.w,
        h: this._data.h,
        mountX: 0.5, // Center horizontally
        x: this._data.w / 2, // Use a fixed value for positioning
        mountY: 0.5, // Center vertically
        y: this._data.h / 2, // Use a fixed value for positioning
      });
    }
  }

  _focus() {
    if (this._data.icon) {
      this._Title.patch({
        // w: this._data.w,
        // h: this._data.h,
        color: Colors('#02AC25').get(),
      });
    } else {
      this._Key.patch({
        // w: this._data.w,
        // h: this._data.h,
        texture: Lightning.Tools.getRoundRect(60, 70, 13, 4, Colors('#02AC25').get(), false),
        color: Colors('#ffffff').get(),
      });
      this._Title.patch({
        color: Colors('#ffffff').get(),
      });
    }
  }

  _unfocus() {
    if (this._data.icon) {
      this._Title.patch({
        // w: this._data.w,
        // h: this._data.h,
        color: Colors('#ffffff').get(),
      });
    } else {
      this._Key.patch({
        // w: this._data.w,
        // h: this._data.h,
        color: Colors('#000000').get(),
      });
      this._Title.patch({
        color: Colors('#ffffff').get(),
      });
    }
  }

  _handleHover() {
    this.fireAncestors('$setState', 'Keyboard');
    this.fireAncestors('$setFocusKey', { row: this._rowIndex, index: this._index });
    this._focus();
  }

  _handleUnhover() {
    this._unfocus();
  }

  _handleEnter() {
    this.fireAncestors('$onSoftKey', { key: this._data.key });
  }

  _handleClick() {
    this._handleEnter();
  }
}
